// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "p[data-v-8dee3d20]{margin-bottom:0}a[data-v-8dee3d20]{color:#29b8ac}.link-item[data-v-8dee3d20]{display:inline-block}.link-separator[data-v-8dee3d20]{margin:0 8px}", ""]);
// Exports
module.exports = exports;
